<template>
    <form>
        <slot></slot>
    </form>
</template>

<script>
    export default {
        name: "FormTag"
    }
</script>

<style scoped>

</style>